import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { finalize } from 'rxjs';
import { MESSAGE_CONSTANTS, STATUS_CODES } from 'src/app/constants';
import {
  OrganizationService,
  OrganizationSettingsService,
  ToasterService,
} from 'src/app/services';
import { NightwebUtil } from 'src/app/utils';

@Component({
    selector: 'app-organization-settings-modal',
    templateUrl: './organization-settings-modal.component.html',
    standalone: false
})
export class OrganizationSettingsModalComponent implements OnInit {
  title!: string;
  cancelButtonLabel = 'Cancel';
  formData: any = {};
  settingsForm!: FormGroup;
  organizationId = '';
  organizationName = '';
  loading = false;
  status_codes = STATUS_CODES;

  constructor(
    private formBuilder: FormBuilder,
    public modalRef: MdbModalRef<OrganizationSettingsModalComponent>,
    private organizationService: OrganizationService,
    private toasterService: ToasterService,
    private organizationSettings: OrganizationSettingsService,
    private nightwebUtil: NightwebUtil,
  ) {
    this.settingsForm = this.formBuilder.group({
      threatPairModuleEnabled: [false],
    });
  }

  ngOnInit(): void {
    const org = this.formData?.organization;
    this.organizationId = org?.id ?? '';
    this.organizationName = org?.businessName ?? org?.name ?? '';
    const settings = org?.settings;
    const enabled = settings?.threatPairModuleEnabled === true;
    this.settingsForm.patchValue({ threatPairModuleEnabled: enabled });
  }

  save(): void {
    if (!this.organizationId || this.loading) {
      return;
    }
    const threatPairModuleEnabled = !!this.settingsForm.get(
      'threatPairModuleEnabled',
    )?.value;
    this.loading = true;
    this.organizationService
      .patchOrganizationSettings(this.organizationId, {
        threatPairModuleEnabled,
      })
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (response: any) => {
          if (response?.statusCode == this.status_codes.OK) {
            this.toasterService.show(
              'Success',
              MESSAGE_CONSTANTS.ORG_SETTINGS_UPDATED,
            );
            const payload = this.nightwebUtil.decodeToken(
              this.nightwebUtil.getLoggedInUser(),
            );
            console.log('payload', payload);
            const userOrgId =
              payload?.organization?.organizationId ??
              payload?.organization?._id;
            this.organizationSettings.syncThreatPairIfCurrentOrg(
              this.organizationId,
              threatPairModuleEnabled,
              userOrgId,
            );
            this.modalRef.close(true);
          }
        },
        error: () => {},
      });
  }
}
